// Module
var code = `<div class="filters">
  <div class="labelled-field" ng-if="!\$ctrl.hideDate">
    <label>Statement as of date</label>
    <date ng-model="\$ctrl.date"
      ng-required="true"
      ng-disabled="!\$ctrl.enableDate"
      min="\$ctrl.minDate"></date>
  </div>
  <div class="labelled-field">
    <label>Checked by</label>
    <select
            ng-model="\$ctrl.checkedByName"
            ng-options="u.fullName as u.fullName for u in \$ctrl.users"
            ng-required="false">
    </select>
  </div>
  <div class="labelled-field">
    <label>Approved by</label>
    <select
            ng-model="\$ctrl.approvedByName"
            ng-options="u.fullName as u.fullName for u in \$ctrl.users"
            ng-required="false">
    </select>
  </div>
  <button type="button" class="btn btn-danger" ng-click="\$ctrl.close()">
    Cancel
  </button>
  <button type="button" class="btn btn-success" ng-click="\$ctrl.displayReport()">
    Display
  </button>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/loan/report-approvals-filters.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;